<template>
  <div id="app">
    <transition name="nexum-fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <overlay :isOpen="overlay" :error="error"></overlay>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import MediaQueryMixin from './mixin/mediaquery.mixin';
  import Overlay from './components/Overlay';

  let ticking = false;
  let lastKnownScrollPosition = 0;

  export default {
    name: 'app',
    mixins: [MediaQueryMixin],
    components: { Overlay },
    data() {
      return {
      };
    },
    computed: {
      ...mapState(['overlay', 'error']),
    },
    watch: {
      device: {
        handler(val) {
          if (val) {
            this.$store.dispatch('changeWindowDeviceAction', val);
          }
        },
      },
      width: {
        handler(val) {
          if (val) {
            this.$store.dispatch('changeWindowWidthAction', val);
          }
        },
      },
      height: {
        handler(val) {
          if (val) {
            this.$store.dispatch('changeWindowHeightAction', val);
          }
        },
      },
    },
    methods: {
      handleScroll() {
        // see https://developer.mozilla.org/es/docs/Web/Reference/Events/scroll
        lastKnownScrollPosition = window.scrollY;
        if (!ticking) {
          window.requestAnimationFrame(() => {
            this.$store.dispatch('changeScrollYAction', lastKnownScrollPosition);
            ticking = false;
          });
        }
        ticking = true;
      },
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
  };
</script>

<style lang="scss">
  @import "./theme/nexum-bootstrap.scss";
  @import "../node_modules/bootstrap/scss/bootstrap.scss";
  $fa-font-path: "../node_modules/font-awesome/fonts/";
  @import '../node_modules/font-awesome/scss/font-awesome.scss';
  @import '../node_modules/v-calendar/lib/v-calendar.min.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

  html, body {
    height: 100vh;
  }
  .btn-primary-linear {
    background-image: $brand-primary-linear;
    color: white;
  }

  .btn-primary {
    background-color: $btn-primary;
  }

  .btn-sm {
    font-size: 0.7rem;
  }

  html {
    height: 100%;
  }
  .modal-header{
    background: $headers-blue;
    color: #fff;
    .close {
      color: #fff;
    }
  }
  input {
    display: block;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-b
  }
  .nexum-box-card {
    width: 100%;
    .card {
      /*  .card-header {
          padding: 0.25rem 0.50rem;
          background-color: $nexum-box-header-color;
          color: white;
          text-align: left;
        }*/
      .card-header {
        background: $headers-blue;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: none;
        color: #fff;
        .text-muted{
          color: #fff !important;
        }
      }
      .card-footer {
        background: $background-forms;
      }
      .card-body {
        padding-top: 0;
        text-align: left;
      }
    }
  }
  .vdatetime-popup__header {
    background: $linear-orange;
  }
  .vdatetime-calendar__month__day--selected > span > span, .vdatetime-calendar__month__day--selected:hover > span > span {
    background: $brand-primary;
  }
  .nexum-datetime {
    input {
      border: 1px solid gray;
      text-align: center;
    }
    > div {
      position: fixed;
      z-index: 3000;
      .vdatetime-popup {
        .vdatetime-popup__header {
          background-image: $linear-orange;
        }
        .vdatetime-popup__actions {
          .vdatetime-popup__actions__button {
            color: $brand-primary;
          }
        }
        .vdatetime-popup__date-picker__item--selected {
          span {
            span {
              background-color: $brand-primary;
            }
          }
        }

      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue